export default __webpack_public_path__ + "finsuite-text.de24a4a5.svg";